export interface FaqItem {
  question: string;
  answer: string;
}

export const FAQ: FaqItem[] = [
  {
    question: 'Сколько времени занимает подключение?',
    answer:
      'Регистрация и создание заведения занимают около десяти минут. Загрузка меню и настройка принтера в среднем час. Помогаем на этапе запуска без дополнительной оплаты.',
  },
  {
    question: 'Есть ли бесплатный период?',
    answer:
      'Да. Первые 7 дней предоставляем полный доступ к системе. Карта при регистрации не требуется, автосписание не включается. Решение об оплате принимаете после теста.',
  },
  {
    question: 'Как подключить приём оплат картой в меню?',
    answer:
      'В разделе «Настройки → Оплата» указываете Shop ID и секретный ключ из личного кабинета ЮKassa. Деньги поступают напрямую на ваш расчётный счёт: мы в цепочке не участвуем и комиссии не берём.',
  },
  {
    question: 'Что с чеками и 54-ФЗ?',
    answer:
      'Фискализация идёт через ЮKassa или совместимую облачную кассу. В настройках указываете ИНН и систему налогообложения, после этого электронные чеки отправляются клиенту автоматически.',
  },
  {
    question: 'Можно ли перейти с другой системы?',
    answer:
      'Да. Помогаем перенести меню и историю заказов из iiko, r_keeper и Poster. Можно и самостоятельно, через импорт CSV.',
  },
  {
    question: 'Что будет, если не оплатить подписку вовремя?',
    answer:
      'Есть три дня льготного периода с уведомлениями. После этого админка переходит в режим просмотра, касса и меню временно блокируются. Данные сохраняются 90 дней: как только оплатите, работа продолжается.',
  },
];
